enum EQueryKeys {
  GET_USER_REGISTER = "GET_USER_REGISTER",
  GET_USER_SUBSCRIBE = "GET_USER_SUBSCRIBE",

  // Warehouse Management
  GET_WAREHOUSES = "GET_WAREHOUSES",
  GET_WAREHOUSE_BY_UUID = "GET_WAREHOUSE_BY_UUID",
  GET_WAREHOUSE_OPTIONS = "GET_WAREHOUSE_OPTIONS",

  // Delivery Schedule Management
  GET_DELIVERY_SCHEDULES = "GET_DELIVERY_SCHEDULES",
  GET_DELIVERY_SCHEDULES_BY_WAREHOUSE = "GET_DELIVERY_SCHEDULES_BY_WAREHOUSE",
  GET_DELIVERY_SCHEDULE_BY_UUID = "GET_DELIVERY_SCHEDULE_BY_UUID",
  GET_DELIVERY_SCHEDULE_OPTIONS = "GET_DELIVERY_SCHEDULE_OPTIONS",

  // Admin Delivery Sheet Management
  GET_ADMIN_DELIVERY_SHEETS = "GET_ADMIN_DELIVERY_SHEETS",
  GET_ADMIN_DELIVERY_SHEET_STATISTICS = "GET_ADMIN_DELIVERY_SHEET_STATISTICS",
  GET_ADMIN_DELIVERY_SHEET_DETAIL = "GET_ADMIN_DELIVERY_SHEET_DETAIL",
  GET_ADMIN_ROUTE_OPERATIONS = "GET_ADMIN_ROUTE_OPERATIONS",
  GET_ADMIN_ROUTE_OPERATION_DETAIL = "GET_ADMIN_ROUTE_OPERATION_DETAIL",
  GET_TRANSPORT_ROUTE_PLANNING_SCOPE = "GET_TRANSPORT_ROUTE_PLANNING_SCOPE",
  GET_TRANSPORT_MANAGER_DC_SCOPES = "GET_TRANSPORT_MANAGER_DC_SCOPES",
  GET_TRANSPORT_ROUTE_PLANNING_CANDIDATES = "GET_TRANSPORT_ROUTE_PLANNING_CANDIDATES",
  GET_TRANSPORT_ROUTE_PLANNING_DRAFTS = "GET_TRANSPORT_ROUTE_PLANNING_DRAFTS",
  GET_TRANSPORT_ROUTE_PLANNING_DRAFT = "GET_TRANSPORT_ROUTE_PLANNING_DRAFT",
  GET_TRANSPORT_ROUTE_PLANNING_RECONCILE = "GET_TRANSPORT_ROUTE_PLANNING_RECONCILE",
  GET_OSRM_ROUTE_SYNC_REVIEWS = "GET_OSRM_ROUTE_SYNC_REVIEWS",
  GET_OSRM_ROUTE_SYNC_REVIEW = "GET_OSRM_ROUTE_SYNC_REVIEW",
  GET_OSRM_ROUTE_SYNC_DELIVERY_NOTIFICATION = "GET_OSRM_ROUTE_SYNC_DELIVERY_NOTIFICATION",
  GET_OSRM_ROUTE_SYNC_SETTING = "GET_OSRM_ROUTE_SYNC_SETTING",
  GET_ADMIN_PACKAGING_TYPES = "GET_ADMIN_PACKAGING_TYPES",
  GET_ADMIN_PRODUCT_PACKAGING_RULES = "GET_ADMIN_PRODUCT_PACKAGING_RULES",

  // Dashboard Summary
  GET_DASHBOARD_SUMMARY = "GET_DASHBOARD_SUMMARY",
  GET_AI_INSIGHT = "GET_AI_INSIGHT",

  // Day Master
  GET_DAY_MASTER = "GET_DAY_MASTER",
}

export default EQueryKeys;
